import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Index from "@/pages/Index";
import PaydayLoans from "@/pages/PaydayLoans";
import PersonalLoans from "@/pages/PersonalLoans";
import HowItWorks from "@/pages/HowItWorks";
import FAQ from "@/pages/FAQ";
import NotFound from "@/pages/NotFound";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Index />,
  },
  {
    path: "/payday-loans",
    element: <PaydayLoans />,
  },
  {
    path: "/personal-loans",
    element: <PersonalLoans />,
  },
  {
    path: "/how-it-works",
    element: <HowItWorks />,
  },
  {
    path: "/faq",
    element: <FAQ />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export function BrowserRouter({ children }: { children: React.ReactNode }) {
  return <RouterProvider router={router} />;
}

export { Link, useNavigate, useLocation } from "react-router-dom";